<template>
  <div id="app">
    <appHeader></appHeader>
    <router-view />
    <appFooter></appFooter>
  </div>
</template>
<script>
import appFooter from "./components/app-footer";
import appHeader from "./components/app-header";
export default {
  name: "App",
  components: {
    appFooter,
    appHeader,
  },
};
</script>
<style lang="scss" >
body {
  padding: 0;
  margin: 0;
}
a{ 
  text-decoration: none;
  color: inherit;
}
.max-w {
  max-width: calc(1920px - 640px);
}
</style>
